

$('.lounching_soon .product__info-wrapper.grid__item').addClass('collection-coming-soon-label');

$(document).ready(function () {
  function initSlider_main() {
    if (typeof $.fn.slick === 'undefined') {
      setTimeout(initSlider_main, 100);
      //console.log('initSlider_main ... slick undefined');
      return;
    }
    console.log('initSlider_main');
    $(".main-images").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      adaptiveHeight: false,
      infinite: false,
      dots: true,
      fade: false,
      asNavFor: ".thumnail-images",
      prevArrow:
        '<button class="slick-prev pull-left"><svg xmlns="http://www.w3.org/2000/svg" width="47" height="50" viewBox="0 0 47 50"><g><g><g><g><path fill="#fff" d="M11 25.5C11 18.596 16.596 13 23.5 13S36 18.596 36 25.5 30.404 38 23.5 38 11 32.404 11 25.5z"/></g><g><g><path fill="none" stroke="#141313" stroke-linecap="round" stroke-miterlimit="20" stroke-width="2" d="M20.028 24.806l6.481 4.63"/></g><g><path fill="none" stroke="#141313" stroke-linecap="round" stroke-miterlimit="20" stroke-width="2" d="M20.028 24.806l6.481-4.63"/></g></g></g></g></g></svg></button>',
      nextArrow:
        '<button class="slick-next pull-right"><svg xmlns="http://www.w3.org/2000/svg" width="47" height="50" viewBox="0 0 47 50"><g><g><g><g><path fill="#fff" d="M11 25.5C11 18.596 16.596 13 23.5 13S36 18.596 36 25.5 30.404 38 23.5 38 11 32.404 11 25.5z"/></g><g><g><path fill="none" stroke="#141313" stroke-linecap="round" stroke-miterlimit="20" stroke-width="2" d="M26.972 24.806l-6.481 4.63"/></g><g><path fill="none" stroke="#141313" stroke-linecap="round" stroke-miterlimit="20" stroke-width="2" d="M26.972 24.806l-6.481-4.63"/></g></g></g></g></g></svg></button>',
    });

    $(".main-images").append('<div class="cstm_btn_slider"></div>');
    $(".main-images").find(".slick-prev").appendTo(".cstm_btn_slider");
    $(".main-images").find(".slick-dots").appendTo(".cstm_btn_slider");
    $(".main-images").find(".slick-next").appendTo(".cstm_btn_slider");
  
    $(".thumnail-images").slick({
      infinite: false,
      slidesToShow: 4,
      vertical: true,
      asNavFor: ".main-images",
      dots: false,
      arrows: false,
      focusOnSelect: true,
      verticalSwiping: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            vertical: false,
            verticalSwiping: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            vertical: false,
            verticalSwiping: false,
          },
        },
      ],
    });
   setTimeout(function () {
      var numberOfLiElements = $(".cstm_btn_slider li").length;
      if (numberOfLiElements < 2) {
        $(".cstm_btn_slider").hide();
      }
     //2024-06-28
     // document.querySelector('.goOnZoom').addEventListener('mousemove', function(event) {
     //     zoom(event);
     // });
    }, 200);
  }
  initSlider_main();
});


// Click event on #openNav
$(document).on("click", "#openNav", function () {
  $(this).siblings("#mySidenav").css("right", "0");
  $(this).siblings("#mySidenavIng").css("right", "-500px");
});

// Click event on .closebtn
$(".closebtn").click(function () {
  $(this).parent("#mySidenav").css("right", "-500px");
});
// Click event on #openNavimg
$(document).on("click", "#openNavimg", function () {
  $(this).siblings("#mySidenavIng").css("right", "0");
  $(this).siblings("#mySidenav").css("right", "-500px");
});

// Click event on .closebtnimg
$(".closebtnimg").click(function () {
  $(this).parent("#mySidenavIng").css("right", "-500px");
});


$("body").click(function () {
  $("#mySidenavIng, #mySidenav").css("right", "-500px");
});
$('#mySidenavIng, #mySidenav').click(function (e) { 
     e.stopPropagation();
   });

// COMBO PRODUCTS TABS
var tabSelector = '.product-description__icon-tab';
var panelSelector = '.product-description__icon-tabpanel';
var panelSelector2 = '.product-ben_pop';

var activateTab = function($tab) {
var tabId = $tab.attr('aria-controls');
var favId = $tab.attr('aria-fav');
  $(panelSelector).addClass('hide');
  $(panelSelector2).addClass('hide');
  $('#' + tabId).removeClass('hide');
  $('#' + favId).removeClass('hide'); 
  $(tabSelector).removeClass('active');
  $tab.addClass('active');
};

var initialTab = $(tabSelector + ':first-child');
activateTab(initialTab);

$(tabSelector).on('click', function() {
  activateTab($(this));
});

function initializeAccordion() {
    if (window.jQuery) { // Check if jQuery is loaded
        // Define a flag to check if initialization has already occurred
        let initialized = false;

        // Shared initialization function
        function initialize() {
            if (initialized) return; // Check the flag to prevent multiple initializations
            initialized = true; // Set the flag to true
            console.log('Accordion init - product-page.js');

            // Accordion initialization logic
            var $question_one = $('.custom_accordion_head');
            var $answer_one = $('.custom_accordion_body');
            $question_one.click(function() {
                $answer_one.slideUp(60);
                if ($(this).hasClass('active')) {
                    $(this).removeClass('active').next($answer_one).slideUp(60);
                } else {
                    $question_one.removeClass('active');
                    $(this).addClass('active').next($answer_one).slideDown(60);
                }
                var activeAccordion = $(this).find('.expang_bg img').attr('src');
                $(this).parents('.accordion_row').find('.active_accordion_img img').attr('src', activeAccordion);
            });

            var faqWrapHeight = $('.faq_wrap').height();
            $('.accordion_col_left').height(faqWrapHeight);
        }

        // IntersectionObserver callback
        function handleIntersect(entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    initialize(); // Trigger initialization
                    observer.disconnect(); // Stop observing once initialized
                }
            });
        }

        // Create the IntersectionObserver instance
        const observer = new IntersectionObserver(handleIntersect, {
            root: null, // Use the viewport as the root
            rootMargin: '99px' // No margin around the root
        });

        // Start observing the .custom_accordion_head element
        const accordionHead = document.querySelector('.custom_accordion_head');
        if (accordionHead) {
            observer.observe(accordionHead);
        }
    } else {
        setTimeout(initializeAccordion, 9); // Check again immediately
    }
}

initializeAccordion(); // Start the initialization process
// $(function () {
//   setTimeout(function(){
  
//     $(".rc-template__radio").addClass('widget_show');
//   }, 2000);
// });


// // Window load event
// $(document).ready(function () {
//   // Delayed execution 
//   setTimeout(function () {
//     // Append a custom element to the radio element
//     $(".recharge-subscription-widget .rc-template__radio").append(
//       '<div class="cstm_recharge_style"></div>'
//     );

//     // Extract and manipulate the text of the onetime-radio element
//     var onetimeText = $(".rc-radio.onetime-radio span.rc-radio__label").text();
//     var onetimeSplit = onetimeText.split("$");

//     $("label.rc-radio.onetime-radio").append(
//       '<span class="rc-radio__label_custom"><span class="one_time_txt">' +
//         onetimeSplit[0] +
//         '</span> <span class="one_time_prc">$' +
//         onetimeSplit[1] +
//         "</span></span>"
//     );

//     // Append a custom element to the subscription-radio element
//     $(".rc-radio.subscription-radio span.rc-radio__price").append(
//       '<span class="subscription_otp"></span>'
//     );

//     // Move elements to a custom recharge style container
//     $(
//       ".rc-radio.subscription-radio, .rc-selling-plans"
//     ).appendTo(".cstm_recharge_style");

//     // Extract subscription price and update the subscription element
//     var subscriptionPrice = "$" + onetimeSplit[1];
//     var $subscriptionRadioPrice = $(
//       ".rc-radio.subscription-radio span.rc-radio__price"
//     );
//     $subscriptionRadioPrice.find(".subscription_otp").remove();
//     $subscriptionRadioPrice.append(
//       '<span class="subscription_otp">' + subscriptionPrice + "</span>"
//     );

//     // Check if the subscription-radio is initially active
//     if ($(".rc-radio.subscription-radio").hasClass("rc-radio--active")) {
//       // Update elements based on subscription price
//       var subscriptionPriceText = $subscriptionRadioPrice.clone().children().remove().end().text().trim();
//        $(".buy_custom .price-item--regular").text(subscriptionPriceText);
//        $(".buy_custom .price-item--regular").text(subscriptionPriceText).addClass("active");
//        $("span.price-item.price-item--sale.price-item--last").addClass("remove");

//     // Update hidden variable prices
//       $(".product-form__input label").each(function () {
//         // Extract variable IDs and calculate savings
//         var sale_id = $(this).find("span.my_var_id").attr("var_id_var");
//         var var_id = $(this)
//           .find("select.sell_plan optgroup[var_id='" + sale_id + "']")
//           .attr("var_id");
//         var varr_opt = $(this)
//           .find("select.sell_plan optgroup[var_id='" + sale_id + "']")
//           .find("option")
//           .attr("price");
//         var varr_optSplit = varr_opt.split("$");
//         var less_prc = $(this).find(".hiden_var_prc").text();
//         var less_prcSplit = less_prc.split("$");

//         var tot = parseFloat(less_prcSplit[1]) - parseFloat(varr_optSplit[1]);
//         var formattedTotal = tot.toFixed(2);
//         $(this)
//           .find(".my_var_id[var_id_var='" + var_id + "']")
//           .text("Save $" + formattedTotal);
//       });

//       // Hide and show specific elements
//       $("span.ot_pr.svae_price").hide();
//       $("span.svae_price.my_var_id").show();
//     }

//     // Extract and calculate total price based on quantity
//     var qty = $(".product quantity-input.quantity input.quantity__input").val();
//     var prc = "";
//     if ($(".rc-radio.subscription-radio").hasClass("rc-radio--active")) {
//       prc = $(".cstm_recharge_style span.rc-radio__price").text().split("$")[1];
//     } else if ($(".rc-radio.onetime-radio").hasClass("rc-radio--active")) {
//       prc = $(".rc-template__radio span.one_time_prc").text().split("$")[1];
//     }
//     var totalPrice = parseFloat(qty) * parseFloat(prc);
//     var aa = $(".buy_custom .price-item").text("$" + totalPrice.toFixed(2));
    



//   }, 1500);

//   // Update class based on condition
//   setTimeout(function () {
//     $(".product-form__input label").each(function () {
//       var my_val = $(this).find("span.ot_pr.svae_price").text();
//       if (my_val.includes("00.00")) {
//         $(this).find("span.ot_pr.svae_price").addClass("value_none");
//       }

//       var checkVal = $(this).find("span.svae_price.my_var_id").text();

//       // Remove class 'value_none' if checkVal is not empty
//       $(this).find("span.svae_price.my_var_id").removeClass("value_none");
//       if (checkVal == "") {
//         // Add class 'value_none' if checkVal is empty
//         $(this).find("span.svae_price.my_var_id").addClass("value_none");
//       }
//     });
   
//   }, 200);
//   var btn_price = $('.product-form__submit .price__container .price-item--regular').text();
//   setTimeout(function () {
//   var button_price = $('.product-form__submit .price__container .price-item--regular').text();
//     if(button_price == '$NaN$NaN'){
//       $('.product-form__submit .price__container .price-item--regular').text(btn_price);
//     }
//   }, 2000);

// });


// $(window).on('load', function() {
//   if ($(".rc-radio.subscription-radio").hasClass("rc-radio--active")) {
//     setTimeout(function () {
//       $(".rc-radio.subscription-radio").parent(".cstm_recharge_style").find(".rc-selling-plans").fadeIn();
//     }, 2000); 
//   }


// });


// // Define a function to encapsulate the logic
// function updatePrices() {
//   setTimeout(function () {
//     $(".product-form__input input[type=radio]").removeClass("active");
//     var real_price = $(".product-form__input label.active span.hiden_var_prc").text();
//     var onetimeText = $("label.rc-radio.onetime-radio span.rc-radio__label").text();
//     var onetimeSplit = onetimeText.split("$");

//     var combinedPriceText =
//       "$" +
//       onetimeSplit[1] +
//       '<span class="real_price">'+real_price+"</span>";
//     $(".rc-radio.onetime-radio .rc-radio__label_custom .one_time_prc").html(combinedPriceText);

//     var subscriptionPrice = real_price;

//     var $subscriptionRadioPrice = $(".rc-radio.subscription-radio span.rc-radio__price");
//     $subscriptionRadioPrice.find(".subscription_otp").remove();
//     $subscriptionRadioPrice.append('<span class="subscription_otp">' + subscriptionPrice + "</span>");


//     if ($(".rc-radio.onetime-radio").hasClass("rc-radio--active")) {
//      $(".buy_custom .price-item--regular").text("$"+onetimeSplit[1]).addClass("active");
//       $("span.price-item.price-item--sale.price-item--last").addClass("remove");
//     }

    
//     if ($(".rc-radio.subscription-radio").hasClass("rc-radio--active")) {
//       var subscriptionPriceText = $subscriptionRadioPrice.clone().children().remove().end().text().trim();
//        $(".buy_custom .price-item--regular").text(subscriptionPriceText).addClass("active");
//       $("span.price-item.price-item--sale.price-item--last").addClass("remove");
     
//     }

// // Get the text content of the elements
// var oneTimePriceText = $(".one_time_prc").contents().not($(".one_time_prc").children()).text();
// var realPriceText = $(".real_price").text();

// // Remove '$' from the strings
// oneTimePrice = oneTimePriceText.replace('$', '');
// realPrice = realPriceText.replace('$', '');

// if(oneTimePrice == realPrice) {
//   //alert('test');
//   $(".real_price").hide();
// } else {
//   $(".real_price").show();
// }


    
//   }, 1200);
// }

// // Call the function on window load
// $(window).on("load", function () {
//   $(".product-form__input label").removeClass("active");
//   $(".product-form__input input[type=radio]:checked+label").addClass("active"); 
//   updatePrices();
// });

// // Also, you can bind the click event as before
// $(document).on("click", ".product-form__input label", function () {
//   $(".product-form__input label").removeClass("active");
//   $(this).addClass("active"); 
//   updatePrices();
// });




// // Click event on quantity button
// $(document).on(
//   "click",
//   ".product-form__input.product-form__quantity .quantity__button",
//   function () {
//     var qty = $(".product quantity-input.quantity input.quantity__input").val();
//     var prc = "";
//     if ($(".rc-radio.subscription-radio").hasClass("rc-radio--active")) {
//       prc = $(".cstm_recharge_style span.rc-radio__price").text().split("$")[1];
//     } else if ($(".rc-radio.onetime-radio").hasClass("rc-radio--active")) {
//       prc = $(".rc-template__radio span.one_time_prc").text().split("$")[1];
//     }
//     var totalPrice = parseFloat(qty) * parseFloat(prc);
//     $(".buy_custom .price-item").text("$" + totalPrice.toFixed(2));
//   }
// );



// // Click event on subscription-radio
// $(document).on("click", ".rc-radio.subscription-radio", function () {
//   // Remove class 'value_none' from span.svae_price.my_var_id
//   $("span.svae_price.my_var_id").removeClass("value_none");

//   // Delayed code execution
//   setTimeout(function () {
//     var $sellingPlans = $(".rc-selling-plans");
//     var $customRechargeStyle = $(".cstm_recharge_style");
//     $customRechargeStyle.children().eq(0).after($sellingPlans);

//     var $subscriptionRadioPrice = $(
//       ".rc-radio.subscription-radio span.rc-radio__price"
//     );
//     if ($(".rc-radio.subscription-radio").hasClass("rc-radio--active")) {
//       var default_price = $(
//         ".product-form__input.custom_input label.active span.hiden_var_prc"
//       ).text();
//       var subscriptionPriceText = $subscriptionRadioPrice.clone().children().remove().end().text().trim();
//       $(".buy_custom .price-item").text(subscriptionPriceText);

//       // Show span.svae_price.my_var_id and hide span.ot_pr.svae_price

//       $(".product-form__input label").each(function () {
//         var checkVal = $(this).find("span.svae_price.my_var_id").text();

//         if (checkVal == "Save $NaN") {
//           $(this).find("span.svae_price.my_var_id").hide();
//         } else {
//           $(this).find("span.svae_price.my_var_id").show();
//         }
//       });

//       $("span.ot_pr.svae_price").hide();

//       // Iterate over custom_input labels and update my_var_id text
//       $(".product-form__input.custom_input label").each(function () {
//         var sale_id = $(this).find("span.my_var_id").attr("var_id_var");
//         var var_id = $(this)
//           .find("select.sell_plan optgroup[var_id='" + sale_id + "']")
//           .attr("var_id");
//         var varr_opt = $(this)
//           .find("select.sell_plan optgroup[var_id='" + sale_id + "']")
//           .find("option")
//           .attr("price");

//         var varr_optSplit = varr_opt.split("$");
//         var less_prc = $(this).find(".hiden_var_prc").text();
//         var less_prcSplit = less_prc.split("$");

//         var tot = parseFloat(less_prcSplit[1]) - parseFloat(varr_optSplit[1]);
//         var formattedTotal = tot.toFixed(2);
//         $(this)
//           .find(".my_var_id[var_id_var='" + var_id + "']")
//           .text("Save $" + formattedTotal);
//       });
//     }
//   }, 200);

// setTimeout(function () {
//     $(".rc-selling-plans").fadeIn();
//   }, 500); 

  
// });



// // Click event on onetime-radio
// $(document).on("click", ".rc-radio.onetime-radio", function () {
//   setTimeout(function () {
//     var $otRadioPrice = $(".rc-radio.onetime-radio span.one_time_prc");
//     if ($(".rc-radio.onetime-radio").hasClass("rc-radio--active")) {
//       var otPriceText = $otRadioPrice.text().split("$")[1];
//       $(".buy_custom .price-item--regular").text("$" + otPriceText);
//       $("span.ot_pr.svae_price").show();
//       $("span.svae_price.my_var_id").hide();
//     }
//   }, 200);
// });





